/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespBuyerAssuranceBox_user$ref: FragmentReference;
export type PdpRespBuyerAssuranceBox_user = {|
  +isVerifiedTrade: ?boolean,
  +$refType: PdpRespBuyerAssuranceBox_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespBuyerAssuranceBox_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5442a9fcd76f6f65e644d9f0d377c9f9';
module.exports = node;
